import {omit, createReducer} from 'helpers';

export const timers = createReducer({}, {

  ACTIVITIES_TOGGLE_TIMER: (state, action) => {
    const activity = action.select('activities.activity', { id: action.id });
    const ts = activity.ts || action.contextDate.unix();
    const id = activity.id + '_' + ts;
    return state[id] ? {} : {
      [id]: {
        id,
        started: action.timestamp,
        isRunning: true,
        activityId: activity.id,
        ts,
      }
    }
  },

  ACTIVITIES_REMOVE_TIMER: (state, {id}) => {
    return omit(state, id);
  }

});
